export enum ButtonText {
  NewAccount = 'new_account',
  NewOrder = 'new_order',
  Register = 'register',
}
